module.exports = __webpack_public_path__ + "img/图片21.042bd86e.png";